
export function GetQueryString(name)
{
     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
     var r = window.location.search.substr(1).match(reg);
     if(r!=null)return  unescape(r[2]); return null;
}


export function IsImageService(file){
  if(!file){
    return false
  }
  file=file.toLowerCase();
  if(file.indexOf(".png")>=0
  ||file.indexOf(".jpg")>=0
  ||file.indexOf(".jpeg")>=0
  ||file.indexOf("bmp")>=0
  ){
    return true
  }
  return false
}

export function clearJsonValue(data,isArrayNull){
  if(data){
    for (let key in data) {
      if (data[key] && (data[key] instanceof Array)) {
        if(isArrayNull){
            data[key] = null
        }else{
          data[key] = []
        }
      } else {
        data[key] = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/Helper.js